import React, { memo } from 'react';
import ButtonMenu from '../../../shared/components/ButtonMenu';
import { uploadSVG } from '../../../shared/helpers/icons';
import SVG from 'react-inlinesvg';
import styles from './addGpsMenu.module.scss';
import { useHistory } from 'react-router-dom';
import { defaultPath } from '../../routes';

const AddGpsMenu = ({ className }) => {
  const history = useHistory();
  const options = [
    {
      label: 'Agregar uno',
      action: () => {
        history.push(`${defaultPath}/gps/new?rows=1`);
      }
    },
    {
      label: 'Agregar 10 o más',
      action: () => {
        history.push(`${defaultPath}/gps/new?rows=10`);
      }
    },
    {
      label: 'Agregar 50 o más',
      action: () => {
        history.push(`${defaultPath}/gps/new?rows=50`);
      }
    },
    {
      label: 'Agregar 100 o más',
      action: () => {
        history.push(`${defaultPath}/gps/new?rows=100`);
      }
    }
  ];

  return (
    <ButtonMenu
      buttonClassName={styles.btnMenu}
      titleButton={(
        <>
        <span className={styles.icon}> + </span>
          <span>Agregar GPS</span>
        </>
      )}
      options={options}
    />
  );
};

export default memo(AddGpsMenu);
